export default __webpack_public_path__ + "static/media/service-img-01.5410b6b3.png";